import React, { useMemo } from "react";
import { Modal, Table, Typography } from "antd";
import { getDayjsFromTimestamp } from "../../../utils/helper";

const { Text } = Typography;

const formatDate = (ts) => {
  const date = getDayjsFromTimestamp(ts);
  return date ? date.format("MM/DD/YYYY") : "—";
};

const PackageTimelineModal = ({ open, onClose, pkg }) => {
  const modalTimelineRows = useMemo(() => {
    if (!pkg?.packageTimeline) return [];
    return Object.entries(pkg.packageTimeline).map(([seasonKey, timeline]) => ({
      key: seasonKey,
      season: seasonKey,
      price:
        timeline.price?.amount !== undefined
          ? `$${timeline.price.amount}${
              timeline.price.type ? ` (${timeline.price.type})` : ""
            }`
          : "—",
      childPrice:
        timeline.childPrice?.amount !== undefined
          ? `$${timeline.childPrice.amount}`
          : "—",
      expiry: formatDate(timeline.expiryDate),
    }));
  }, [pkg]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={pkg?.name || "Package timeline"}
      width={720}
    >
      <div style={{ marginTop: 8 }}>
        {modalTimelineRows && modalTimelineRows.length > 0 ? (
          <Table
            size="small"
            bordered
            pagination={false}
            columns={[
              { title: "Season", dataIndex: "season", key: "season" },
              { title: "Price", dataIndex: "price", key: "price" },
              {
                title: "Child Price",
                dataIndex: "childPrice",
                key: "childPrice",
              },
              { title: "Expiry", dataIndex: "expiry", key: "expiry" },
            ]}
            dataSource={modalTimelineRows}
          />
        ) : (
          <Text type="secondary">No timeline data</Text>
        )}
      </div>
    </Modal>
  );
};

export default PackageTimelineModal;
